/*! Version: b91cd8f9 */
webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trans = trans;

var _translations = __webpack_require__(5);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* globals console window */

// Translation utility function

// Initalize translations. Find the table, and warn if empty
if (Object.keys(_translations2.default).length !== 0) {
  audit();
} else {}

/**
 * Translates a single string based on a global context translation table.
 * @param {string} sourceString - The string to be translated
 * @returns {string}
 */
function trans(sourceString) {
  if (_translations2.default.hasOwnProperty(sourceString)) {
    // If a translation exists, just return it
    return _translations2.default[sourceString];
  } else {

    // Find a similar string except with different case
    for (var key in _translations2.default) {
      if (sourceString.toLowerCase() === key.toLowerCase() && window.locale !== "en_US") {}
    }

    // Return original string untouched (on failure)

    // If no translation exists, let the user know
    return sourceString;
  }
}

/**
 * Performs an audit of the translation table, checking that all translations
 * are okay and any other audits which could help development
 */
function audit() {
  for (var key in _translations2.default) {
    if (key === _translations2.default[key] && window.locale !== "en") {}
  }
}

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

module.exports = _TRANSLATIONS;

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports) {

module.exports = locale;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeCommentsOverlay = closeCommentsOverlay;
exports.openCommentsOverlay = openCommentsOverlay;
exports.bindCommentsOverlay = bindCommentsOverlay;

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commentsOverlay = void 0; /* globals document */


var CLASS_COMMENTS_OVERLAY_ACTIVE = "c-comments-overlay--active";

(0, _jquery2.default)(function () {
  commentsOverlay = (0, _jquery2.default)(".c-comments-overlay");
});

function closeCommentsOverlay() {
  commentsOverlay.removeClass(CLASS_COMMENTS_OVERLAY_ACTIVE);
}

function openCommentsOverlay() {
  commentsOverlay.addClass(CLASS_COMMENTS_OVERLAY_ACTIVE);
  commentsOverlay.focus();
  commentsOverlay.find("iframe").css({
    height: "100%"
  });
}

function bindCommentsOverlay() {
  (0, _jquery2.default)(document).on("keydown", function (e) {
    if (e.key === "Escape") {
      closeCommentsOverlay();
    }
  });

  (0, _jquery2.default)(document).on("mouseup touchend click", ".c-comments-overlay--active", function (event) {
    if (event.target.className !== "c-comments-overlay__content") {
      closeCommentsOverlay();
    }
  });
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventBus = undefined;

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventBus = exports.EventBus = new _vue2.default(); // This stub creates a vue.js event bus. It is useful in some cases where
// events need to be passed between objects but their relationship is not
// necessarily direct parent-child.

// More info:
//   https://alligator.io/vuejs/global-event-bus/

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _moment = __webpack_require__(3);

var _moment2 = _interopRequireDefault(_moment);

var _translate = __webpack_require__(2);

var _commentsOverlay = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global require document */
exports.default = _vue2.default.component("discussion", {
  props: ["data"],

  data: function data() {
    return {
      trans: _translate.trans
    };
  },


  methods: {
    formatDate: function formatDate(date) {
      return (0, _moment2.default)(date).format("MMM D YYYY, H:mm");
    },
    openCommentsOverlay: function openCommentsOverlay() {
      (0, _commentsOverlay.openCommentsOverlay)();
    }
  },

  template: __webpack_require__(24)
});

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = "<div class=c-comment__section-container> <ul class=c-comment__list-container v-if=data.response.length> <li class=c-comment :class=\"{'c-comment--last': index == data.response.length - 1}\" v-for=\"(comment, index) in data.response\"> <div class=c-comment__metadata> <img class=c-comment__author-avatar :src=comment.author.avatar.cache :alt=\"trans('Profile picture:') + comment.author.name\"> <div class=c-comment__author-name> {{ comment.author.name }} </div> <span class=c-comment__date> {{ formatDate(comment.createdAt) }} </span> </div> <div class=c-comment__body v-html=comment.message></div> </li> </ul> <div v-else class=c-comment__empty-state> {{ trans(\"No comments yet\") }}. </div> <div class=c-comment__separator> <button class=c-comment__add-comment @click=openCommentsOverlay>{{ trans(\"Add a comment\") }}</button> </div> </div> ";

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports) {

module.exports = page;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _translate = __webpack_require__(2);

__webpack_require__(47);

__webpack_require__(48);

__webpack_require__(50);

__webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Child components
/* global require */
exports.default = _vue2.default.component("search-sidebar", {
  props: ["groups", "freetext", "subqueries", "state", "isManuscript"],

  data: function data() {
    return {
      trans: _translate.trans,
      manuscriptModel: this.isManuscript ? __webpack_require__(52) : {}
    };
  },


  computed: {
    filteredSubqueries: function filteredSubqueries() {
      if (!this.isManuscript) {
        return this.subqueries;
      } else {
        return this.subqueries.filter(function (f) {
          return f.fieldname !== "manuscript_numbers";
        });
      }
    }
  },

  template: __webpack_require__(142)
});

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _translate = __webpack_require__(2);

var _eventBus = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _vue2.default.component("filter-chip", {
  props: ["filter"],

  data: function data() {
    return { trans: _translate.trans };
  },


  methods: {
    emitRemoveFilter: function emitRemoveFilter(name, group) {
      _eventBus.EventBus.$emit("query-without-filter", [name, group]);
    }
  },

  template: __webpack_require__(136)
}); /* global require */

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _translate = __webpack_require__(2);

var _clickOutside = __webpack_require__(49);

__webpack_require__(137);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global require */
exports.default = _vue2.default.component("facet-group", {
  props: ["group", "isManuscript", "tabindex"],
  data: function data() {
    return { trans: _translate.trans, overflowOpen: false };
  },


  computed: {
    hasOverflow: function hasOverflow() {
      return this.group.groups.more.length > 0;
    }
  },

  directives: {
    clickOutside: _clickOutside.clickOutside
  },

  methods: {
    collapseOverflow: function collapseOverflow() {
      this.overflowOpen = false;
    }
  },

  template: __webpack_require__(139)
});

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* global document */

// This stub defines a clickOutside directive, reusable across components if
// need be.

// This custom directive adds the ability for triggers to occur on clicks
// outside of an element.  Based on this SO answer:
//   https://stackoverflow.com/a/42389266

// USAGE:
//
// In the template -
//   <div v-click-outside="clickedOutside"></div>
//
// And in the same component, define a method to do whatever you need -
//   method: {
//     clickedOutside() {
//       // Whatever!
//     }
//   }

var clickOutside = exports.clickOutside = {
  bind: function bind(el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
    document.body.addEventListener("touchend", el.clickOutsideEvent);
  },
  unbind: function unbind(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
    document.body.removeEventListener("touchend", el.clickOutsideEvent);
  }
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _translate = __webpack_require__(2);

var _eventBus = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _vue2.default.component("freetext-search", {
  props: ["value"],

  data: function data() {
    return { trans: _translate.trans, currentQuery: this.value };
  },


  methods: {
    emitQueryChange: function emitQueryChange(value) {
      _eventBus.EventBus.$emit("query-with-freetext", this.currentQuery);
    }
  },

  watch: {
    value: function value(newVal) {
      this.currentQuery = newVal;
    }
  },

  template: __webpack_require__(140)
}); /* global require */

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _translate = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global require */
exports.default = _vue2.default.component("manuscript-metadata", {
  props: ["manuscriptModel"],

  data: function data() {
    var _this = this;

    return {
      trans: _translate.trans,
      // Contains the metadata fields to be checked and displayed to the user
      // in the sidebar
      metadataFields: [["Site", "site"], ["Manuscript Type", "manuscript_type"], ["Composition Type", "composition_type"], ["Language", "script_language"], ["Script", "script_type"], ["Period", "period"], ["Material", "material"]],
      urlForField: function urlForField(metadata) {
        return "/explore-the-archive/search#q=" + metadata[1] + ":'" + _this.manuscriptModel[metadata[1]] + "'";
      }
    };
  },


  template: __webpack_require__(141)
});

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = manuscriptModel;

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(124);

__webpack_require__(164);

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _page = __webpack_require__(45);

var _page2 = _interopRequireDefault(_page);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _commentsOverlay = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (_page2.default === "explore-the-archive") {
  // Only start the faceted list and freetext search
  __webpack_require__(125);
  __webpack_require__(129);
  __webpack_require__(133);
} else {
  // Start the archive flow
  (0, _commentsOverlay.bindCommentsOverlay)();
  __webpack_require__(134);
} /* global console require document */

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _facets = __webpack_require__(126);

var _facets2 = _interopRequireDefault(_facets);

var _facetedList = __webpack_require__(127);

var _facetedList2 = _interopRequireDefault(_facetedList);

var _facet = __webpack_require__(128);

var _facet2 = _interopRequireDefault(_facet);

var _translate = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: The following translations have to be added in localization files:
// * Browse by Site
// * Browse by Language
// * Browse by Content

/* global console window document */

(0, _jquery2.default)(function () {

  // A single facet component, optionally with children
  _vue2.default.component("facet", {
    props: ["name", "count", "children", "url", "nested", "visible"],
    data: function data() {
      return { expanded: false, hasFocus: false, trans: _translate.trans };
    },
    created: function created() {
      var _this = this;

      // Listen to parent collapse events and collapse this item as well
      this.$parent.$on("collapseEvent", function () {
        _this.expanded = false;
      });
    },


    computed: {
      internetExplorer: function internetExplorer() {
        return !!window.MSInputMethodContext && !!document.documentMode;
      }
    },

    methods: {
      clicked: function clicked() {
        if (this.internetExplorer) {
          document.location.href = this.url;
        }
      }
    },
    template: _facet2.default
  });

  // A list of facets with state controls
  var facetedList = _vue2.default.component("faceted-list", {
    props: ["terms", "title"],
    data: function data() {
      return { expanded: false, trans: _translate.trans };
    },

    watch: {
      expanded: function expanded(val) {
        if (!val) {
          // Tell children that this component has collapsed
          this.$emit("collapseEvent");
        }
      }
    },
    template: _facetedList2.default
  });

  // The lists themselves
  new _vue2.default({
    el: "#faceted-list-site",
    render: function render(cElm) {
      return cElm(facetedList, {
        props: {
          title: (0, _translate.trans)("Browse by Site"),
          terms: _facets2.default.site
        }
      });
    }
  });
  new _vue2.default({
    el: "#faceted-list-language",
    render: function render(cElm) {
      return cElm(facetedList, {
        props: {
          title: (0, _translate.trans)("Browse by Language"),
          terms: _facets2.default.language
        }
      });
    }
  });
  new _vue2.default({
    el: "#faceted-list-content",
    render: function render(cElm) {
      return cElm(facetedList, {
        props: {
          title: (0, _translate.trans)("Browse by Content"),
          terms: _facets2.default.content
        }
      });
    }
  });

  // Top box / help box
  new _vue2.default({
    el: "#faceted-list-top-box-site",
    data: { flipped: false }
  });
  new _vue2.default({
    el: "#faceted-list-top-box-language",
    data: { flipped: false }
  });
  new _vue2.default({
    el: "#faceted-list-top-box-content",
    data: { flipped: false }
  });
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = facets;

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports = "<div> <ul class=c-explore-by> <facet v-for=\"(f, index) in terms\" :key=f.name :children=f.children :nested=false :name=f.name :count=f.count :visible=\"expanded || index < 5\" :url=f.url /> </ul> <button role=switch :aria-checked=\"expanded + ''\" :title=\"trans(title) + ': ' + trans(expanded ? 'show less' : 'show more')\" class=c-explore-by__show-more v-on:click=\"expanded = !expanded\"> {{ expanded ? trans(\"show less\") : trans(\"show more\") }} </button> <div role=presentation class=u-clearfix></div> </div> ";

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = "<li class=c-explore-by__item :class=\"{\n      'c-explore-by__item--expanded': expanded,\n      'c-explore-by__item--collapsed': !expanded && children,\n      'c-explore-by__item--nested': nested,\n      'c-explore-by__item--visible': visible,\n    }\" :aria-hidden=!visible> <div v-if=children class=c-explore-by__interactable :title=\"(expanded ? trans('Collapse list') : trans('Expand list')) + ': ' + name\" v-on:blur=\"hasFocus = false\" v-on:focus=\"hasFocus = true\" v-on:click=\"expanded = !expanded\" v-on:keydown.enter=\"expanded = !expanded\" :aria-checked=\"expanded + ''\" :tabindex=\"visible ? 0 : -1\" :class=\"{'c-explore-by__interactable--focus': hasFocus}\"> <span class=c-explore-by__link tabindex=-1> <span class=c-explore-by__term v-html=name>{{name}}</span> &nbsp; <span class=c-explore-by__number>({{count}})</span> </span> <div role=presentation class=c-explore-by__expando v-if=children> <div class=\"i-icon i-faceted-list-expando c-explore-by__expando-icon\" :class=\"{'c-explore-by__expando-icon--active': expanded && children }\" role=presentation></div> </div> </div> <a v-else @click=clicked v-on:blur=\"hasFocus = false\" v-on:focus=\"hasFocus = true\" :tabindex=\"visible ? 0 : -1\" :href=url class=c-explore-by__interactable :class=\"{'c-explore-by__interactable--focus': hasFocus}\"> <a class=c-explore-by__link> <span class=c-explore-by__term>{{name}}</span> &nbsp; <span class=c-explore-by__number>({{count}})</span> </a> </a> <ul v-if=children class=c-explore-by__nested-list :aria-hidden=!expanded :class=\"{ 'c-explore-by__nested-list--expanded': expanded }\"> <facet v-for=\"c in children\" :key=c.name :count=c.count :nested=true :name=c.name :visible=expanded :url=c.url /> </ul> </li> ";

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _moment = __webpack_require__(3);

var _moment2 = _interopRequireDefault(_moment);

var _locale = __webpack_require__(8);

var _locale2 = _interopRequireDefault(_locale);

var _dotdotdot = __webpack_require__(130);

var _dotdotdot2 = _interopRequireDefault(_dotdotdot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//TODO Is there a better place for this constant? Since is it design related it probably shouldn't be here
var commentsToShow = 7;

//The Vue component for a single comment
/* global console require */

_vue2.default.component("latest-comment", {
  props: ["author-name", "author-avatar", "date", "body-text", "scroll-title", "scroll-name", "copy", "scroll-thumbnail", "num-of-comments", "thread-url"],

  template: __webpack_require__(131)
});

//The Vue component for the whole comment list
_vue2.default.component("latest-comments-list", {
  data: function data() {
    return {
      commentList: []
    };
  },


  template: __webpack_require__(132),

  //on creation set up the list of comments
  created: function created() {
    var _this = this;

    var threadIds = []; //ids of the threads in which the latest comments were made
    var latestThreads = {}; //holds objects with info about the above threads
    var filteredComments = []; //holds one comment from each thread

    //objects used for the data requeasts
    var disqusRequestPath = "/api/disqus";
    var commentsRequestData = { endpoint: "/posts/list.json" };
    var threadsRequestData = { endpoint: "/threads/list.json", thread: threadIds };

    //fetch comments data from disqus
    _jquery2.default.getJSON(disqusRequestPath, commentsRequestData, function (returnedData) {
      _jquery2.default.each(returnedData.response, function (index, comment) {
        var threadId = comment.thread;

        //keep only one comment from each thread
        if (threadIds.indexOf(threadId) < 0) {
          threadIds.push(threadId);

          //create fields which will be filled later using the thread metadata objects
          comment.scrollName = "";
          comment.scrollTitle = "";
          comment.scrollThumbnail = "";
          comment.threadUrl = "";
          comment.copy = "";

          //fix the formatting of the date
          var myMoment = (0, _moment2.default)(comment.createdAt);
          myMoment.locale(_locale2.default);
          comment.createdAt = myMoment.format("MMM D YYYY, H:mm");

          filteredComments.push(comment);
        }
      });

      //limit the number of comments to display
      _this.commentList = filteredComments.slice(0, commentsToShow);

      if (_this.commentList.length > 0) {
        //get the basic thread data (scroll id, scroll type and number of comments)
        _jquery2.default.getJSON(disqusRequestPath, threadsRequestData, function (returnedData) {
          latestThreads = parseThreads(returnedData);

          //now get the threads' metadata from the database (scroll names, titles and thumbnail urls)
          getThreadsMetadata(latestThreads, function (threadsMetadata) {
            //add the thread data to the comments
            for (var i = 0; i < _this.commentList.length; i++) {
              _this.buildComment(i, threadsMetadata);
            }
          });
        });
      }
    });
  },
  updated: function updated() {
    truncateComments();
  },


  methods: {
    buildComment: function buildComment(i, threadsMetadata) {
      var threadId = this.commentList[i].thread;
      var threadMetadata = threadsMetadata[threadId];

      //check if the comment is on a manuscript or an image
      if (threadMetadata.type == "manuscript") {
        //add the manuscript name
        this.commentList[i].scrollName = threadMetadata.meta.manuscript_number + " - " + threadMetadata.meta.short_name;
        this.commentList[i].copy = threadMetadata.meta.copy;

        //find the manuscript title in the appropriate language
        if (_locale2.default == "he_IL") {
          this.commentList[i].scrollTitle = threadMetadata.meta.composition_name_he;
        } else {
          this.commentList[i].scrollTitle = threadMetadata.meta.composition_name_en;
        }
      } else {
        //add the scroll name
        this.commentList[i].scrollName = "Plate " + threadMetadata.meta.plate_numbers[0];
        if (threadMetadata.meta.frag_num) {
          this.commentList[i].scrollName += ", frag. " + threadMetadata.meta.frag_num;
        }

        //add the scroll title
        this.commentList[i].scrollTitle = threadMetadata.id;
      }

      //add the scroll thumbnail
      this.commentList[i].scrollThumbnail = threadMetadata.type == "manuscript" ? threadMetadata.meta.thumbnail : threadMetadata.meta.url;
      //add the number of comments in the thread
      this.commentList[i].numOfComments = threadMetadata.postCount;
      //add the thread url
      this.commentList[i].threadUrl = "/explore-the-archive/" + threadMetadata.type + "/" + threadMetadata.id;
    }
  }
});

function getThreadsMetadata(threads, callbackFunction) {

  _jquery2.default.ajax({
    url: "/api/meta",
    type: "POST",
    data: {
      list: JSON.stringify(threads)
    },

    success: function success(data) {
      callbackFunction(data);
    }
  });
  // get names titles and thumbs from datastore:
}

//Create a list of thread objects used to retrieve the threads' metadata
function parseThreads(data) {
  var threads = {};

  // parse types and id's of models:
  _jquery2.default.each(data.response, function (index, item) {
    var id = item.identifiers[item.identifiers.length - 1];
    var slashIndex = id.indexOf("/");
    threads[item.id] = {
      type: id.substring(0, slashIndex),
      id: id.substring(slashIndex + 1),
      postCount: item.posts
    };
  });

  return threads;
}

function truncateComments() {
  (0, _jquery2.default)(".c-latest-comment__body-text").dotdotdot({
    height: "watch",
    truncate: "letter"
  });
}

//onload
(0, _jquery2.default)(function () {
  //The list of comments
  new _vue2.default({
    el: "#latest-comments"
  });
});

/***/ }),
/* 130 */,
/* 131 */
/***/ (function(module, exports) {

module.exports = "<div class=c-latest-comment> <a :href=threadUrl> <div class=\"o-trio-layout u-hide-small\"> <div class=\"c-latest-comment__thread-info o-trio-layout__item\"> <div class=c-latest-comment__scroll-thumbnail :style=\"{ backgroundImage: 'url(' + scrollThumbnail + ')' }\" role=image :aria-label=\"'Thumbnail '+scrollTitle\"></div> <div class=c-latest-comment__scroll-metadata> <div class=c-latest-comment__scroll-title> {{ scrollTitle }} </div> <div class=c-latest-comment__scroll-name>{{ scrollName }}<sup class=c-latest-comment__scroll-copy>{{ copy }}</sup></div> <div class=c-latest-comment__num-of-comments> <span class=c-latest-comment__num-of-comments-text>{{ numOfComments }}</span> <div class=\"i-comment-grey c-latest-comment__num-of-comments-icon\"></div> </div> </div> </div> <div class=\"c-latest-comment__body o-trio-layout__double-item\"> <div class=c-latest-comment__author-name-and-date> <span class=c-latest-comment__author-name> {{ authorName }} </span> <span class=c-latest-comment__date> {{ date }} </span> </div> <div class=c-latest-comment__avatar-and-text> <img class=c-latest-comment__author-avatar :src=authorAvatar /> <div class=c-latest-comment__body-text> {{ bodyText }} </div> </div> </div> </div> <div class=\"u-hide-large u-hide-medium\"> <div class=c-latest-comment__author-info> <img class=c-latest-comment__author-avatar :src=authorAvatar /> <div class=c-latest-comment__author-name-and-date> <div class=c-latest-comment__author-name> {{ authorName }} </div> <div class=c-latest-comment__date> {{ date }} </div> </div> </div> <div class=c-latest-comment__body-text> {{ bodyText }} </div> <div class=c-latest-comment__thread-info> <div class=c-latest-comment__scroll-thumbnail :style=\"{ backgroundImage: 'url(' + scrollThumbnail + ')' }\" role=image :aria-label=\"'Thumbnail '+scrollTitle\"></div> <div class=c-latest-comment__scroll-metadata> <div class=c-latest-comment__scroll-title> {{ scrollTitle }} </div> <div class=c-latest-comment__scroll-name> {{ scrollName }} </div> <div class=c-latest-comment__num-of-comments> <div class=c-latest-comment__num-of-comments-text>{{ numOfComments }}</div> <div class=\"i-comment-grey c-latest-comment__num-of-comments-icon\"></div> </div> </div> </div> </div> </a> </div> ";

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports = "<div class=c-latest-comments__list> <latest-comment v-for=\"comment in commentList\" :body-text=comment.raw_message :author-name=comment.author.name :author-avatar=comment.author.avatar.small.permalink :date=comment.createdAt :scroll-title=comment.scrollTitle :scroll-name=comment.scrollName :copy=comment.copy :scroll-thumbnail=comment.scrollThumbnail :num-of-comments=comment.numOfComments :thread-url=comment.threadUrl> </latest-comment> </div> ";

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
  (0, _jquery2.default)(".c-start-browsing__form-container").on("submit", function (e) {
    var v = (0, _jquery2.default)(".c-start-browsing__search-box").val();
    window.location = "/explore-the-archive/search#q='" + v + "'";
    e.preventDefault();
  });
}); /* global window */

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _searchPage = __webpack_require__(135);

var _searchPage2 = _interopRequireDefault(_searchPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
  // Spawn a search page element
  new _vue2.default({
    el: "#search-page",
    data: {},
    // Define the renderer for the main search result component
    render: function render(cElm) {
      return cElm(_searchPage2.default);
    }
  });
}); /* global console */

// Search logic is implemented here.

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _page = __webpack_require__(45);

var _page2 = _interopRequireDefault(_page);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _translate = __webpack_require__(2);

var _eventBus = __webpack_require__(10);

__webpack_require__(46);

__webpack_require__(143);

__webpack_require__(145);

__webpack_require__(147);

__webpack_require__(149);

__webpack_require__(151);

__webpack_require__(153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* global console window require document */

// window global

// The sidebar bits (searching, showing filters etc.)

// A search result in a search page

// A single result in a manuscript

// Help toggle button

// Mobile sidebar

// Status indicator

// Tablist for comments, notes etc.


exports.default = _vue2.default.component("search-page", {
  data: function data() {
    return {
      isManuscript: _page2.default === "manuscript",
      query: "",
      pages: [],
      loading: false,
      failed: false,
      manuscriptModel: {},
      numComments: {},
      trans: _translate.trans
    };
  },


  // Component methods
  methods: {
    // This method gets a page and feeds it back into the vue component.
    getPage: function getPage(n) {
      var _this = this;

      // Abort if already loading
      if (this.loading) {
        return;
      }

      var apiRequestPath = this.isManuscript ? "/api/search?t=image&" + this.query.replace(/&/g, "%26") + "&p=" + (n || 1) : "/api/search?t=manuscript&" + this.query.replace(/&/g, "%26") + "&p=" + (n || 1);


      // Check if this is internet explorer 11. Due to the way IE11 handles URLs,
      var isIE = !!window.MSInputMethodContext && !!document.documentMode;

      this.loading = true;
      _jquery2.default.getJSON(isIE ? encodeURI(apiRequestPath) : apiRequestPath).done(function (data) {
        if ((n || 1) === 1) {
          _this.pages = [];
        }
        _this.pages.push(data);
        _this.loading = false;
        _this.getCommentsForItems(_this.missingItemsIds);
      }).fail(function () {
        _this.failed = true;
      });
    },
    getNextPage: function getNextPage() {
      this.getPage(this.maxPage + 1);
    },
    getCommentsForItems: function getCommentsForItems(itemIds) {
      var _this2 = this;

      // Fetches comments for itemIds (as an array)
      var disqusApiRequestPath = "/api/disqus?endpoint=/threads/list.json&" + itemIds.map(function (e) {
        return "thread[]=ident:" + (_this2.isManuscript ? "image" : "manuscript") + "/" + e;
      }).join("&");

      _jquery2.default.getJSON(disqusApiRequestPath).done(function (data) {
        var commentTupleArr = data.response.map(function (response) {
          return [response.identifiers.join("").replace(_this2.isManuscript ? "image/" : "manuscript/", ""), response.posts];
          // Return a single tuple
        });

        // Populate numComments from the received tuple array
        var newNumComments = {};
        commentTupleArr.forEach(function (data) {
          newNumComments[data[0]] = data[1];
        });

        _this2.numComments = Object.assign(newNumComments, _this2.numComments);
      });
    },
    queryAsArray: function queryAsArray() {
      // Init with the free text part of the search
      var queryParts = ["'" + this.firstValidPage.freetext + "'"];

      // Populate an array with the current facets
      var currentFacets = this.firstValidPage.subqueries.map(function (e) {
        return e.fieldname + ":'" + e.text + "'";
      });

      // Add the array of current facets to the query array
      queryParts.push.apply(queryParts, currentFacets); // In place concat

      return queryParts;
    },
    queryWithFilter: function queryWithFilter(filterField, filterText) {
      var queryParts = this.queryAsArray();

      // Also add what we're trying to add to the query
      queryParts.push(filterField + ":'" + filterText + "'");

      // Join and return
      this.query = "q=" + queryParts.join("+AND+");
    },
    queryWithoutFilter: function queryWithoutFilter(filterField, filterText) {
      // Find and remove the query
      var queryParts = this.queryAsArray().filter(function (e) {
        return e !== filterField + ":'" + filterText + "'";
      });

      // Join and return
      this.query = "q=" + queryParts.join("+AND+");
    },
    queryWithFreetext: function queryWithFreetext(freetext) {
      // Get a copy of the computed prop
      var queryParts = this.queryAsArray();
      // Modify the first part of the array (alwyas the free text)
      queryParts[0] = "'" + freetext + "'";

      // Join and return
      this.query = "q=" + queryParts.join("+AND+");
    },
    checkEmptyQuery: function checkEmptyQuery() {
      if (this.query == "q=" || this.query == "q=''" || this.query == "") {
        window.location = "/explore-the-archive";
        // Redirect back if query is empty
      }
    }
  },

  computed: {
    flatResults: function flatResults() {
      if (this.pages.length >= 0) {
        return this.pages.map(function (a) {
          return a.results;
        }).reduce(function (a, b) {
          return a.concat(b);
        });
      } else {
        return [];
      }
    },
    allItemsIds: function allItemsIds() {
      var _this3 = this;

      return this.flatResults.map(function (e) {
        return _this3.isManuscript ? e.name : e.manuscript_id;
      });
    },
    missingItemsIds: function missingItemsIds() {
      var keys = Object.keys(this.numComments);
      return this.allItemsIds.filter(function (e) {
        return keys.indexOf(e) === -1;
      });
    },
    firstValidPage: function firstValidPage() {
      return this.pages.find(function (p) {
        return p instanceof Object;
      });
    },
    totalResults: function totalResults() {
      // Total number of results in the query
      var validP = this.firstValidPage;
      if (validP !== undefined) {
        return validP.length;
      } else {
        return -1;
      }
    },
    totalPages: function totalPages() {
      // Total number of pages in query
      var validP = this.firstValidPage;
      if (validP !== undefined) {
        return validP.totalpages;
      } else {
        return -1;
      }
    },
    currentResults: function currentResults() {
      // How many results have been fetched overall?
      return this.pages.map(function (e) {
        if (e !== undefined) {
          return e.results.length;
        } else {
          return 0;
        }
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
    },
    maxPage: function maxPage() {
      // The farthest page reached
      return this.pages.length !== 0 ? Math.max.apply(Math, _toConsumableArray(this.pages.map(function (p) {
        return p.page;
      }))) : 0;
    },
    state: function state() {
      // The current state based on current conditions
      if (this.pages.length === 0 && !this.failed) {
        return "INITIAL_LOADING";
      } else if (this.pages.length !== 0 && !this.loading && !this.failed && this.totalResults == 0) {
        return "NO_RESULTS";
      } else if (this.pages.length !== 0 && this.loading && !this.failed) {
        return "LOADING_MORE";
      } else if (this.pages.length !== 0 && !this.loading && !this.failed) {
        return "IDLE";
      } else if (this.failed) {
        return "ERROR";
      } else {
        return "UNKNOWN";
      }
    },
    hasMorePages: function hasMorePages() {
      return this.state !== "NO_RESULTS" && this.state !== "ERROR" && this.state !== "UNKNOWN" && this.state !== "INITIAL_LOADING" && this.maxPage < this.totalPages;
    }
  },

  watch: {
    query: function query() {
      this.failed = false;

      // Get the first page

      // This will only trigger if query has ACTUALLY changed!
      this.getPage(1);

      if (!this.isManuscript) {
        this.checkEmptyQuery();
        window.location.hash = this.query;
      }
    }
  },

  // On creation
  created: function created() {
    var _this4 = this;

    if (this.isManuscript) {
      // Get the manuscript number from `window.manuscriptNumber`. This is used
      // to initialize the query
      this.manuscriptModel = __webpack_require__(52);
      this.query = "q=manuscript_numbers:'" + this.manuscriptModel.manuscript_number + "'";
    } else {

      // Bind hash change event
      (0, _jquery2.default)(window).on("hashchange", function () {
        var newQuery = window.location.hash.slice(1);
        // Ensure that a query change doesn't set off due to different parsing
        // of the hash (URI encoded vs. not)
        _this4.query = decodeURI(newQuery);
      });

      // Trigger a change of query.
      this.query = window.location.hash.slice(1);

      this.checkEmptyQuery();
    }

    // Bind global bus events.
    _eventBus.EventBus.$on("query-with-freetext", function (value) {
      _this4.queryWithFreetext(value);
    });

    _eventBus.EventBus.$on("query-with-filter", function (value) {
      _this4.queryWithFilter(value[0], value[1]);
    });

    _eventBus.EventBus.$on("query-without-filter", function (value) {
      _this4.queryWithoutFilter(value[0], value[1]);
    });
  },
  mounted: function mounted() {
    document.addEventListener("keydown", function (event) {
      if (event.keyCode == 27) {
        _eventBus.EventBus.$emit("esc-pressed");
      }
    });
  },


  template: __webpack_require__(163)
});

/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports = "<div class=c-search-sidebar__filter-chip-wrapper> <div class=c-search-sidebar__filter-chip> {{filter.text}} </div> <button v-on:click=\"emitRemoveFilter(filter.fieldname, filter.text)\" class=\"c-search-sidebar__filter-chip-remove i-icon i-remove-filter\" :title=\"trans('Remove filter') + ': ' + filter.text\"> {{ trans(\"Remove filter\") + \": \" + filter.text }}</button> </div> ";

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _eventBus = __webpack_require__(10);

var _translate = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _vue2.default.component("facet", {
  props: ["facet", "mode", "fieldname", "tabindex", "isManuscript"],

  data: function data() {
    return {};
  },


  methods: {
    emitAddFilter: function emitAddFilter(name, group) {
      _eventBus.EventBus.$emit("query-with-filter", [name, group]);
    }
  },

  computed: {
    translatedFieldname: function translatedFieldname() {
      return (0, _translate.trans)(this.fieldname);
    }
  },

  template: __webpack_require__(138)
}); /* global require */

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports = "<li class=c-facet-group__facet-wrapper v-bind:class=\"{\n    'c-facet-group__facet-wrapper--overflow': mode == 'overflow',\n    'c-facet-group__facet-wrapper--overflow-standalone': mode == 'overflow-standalone',\n    'c-facet-group__facet-wrapper--manuscript': isManuscript,\n    }\"> <button v-bind:title=\"translatedFieldname + ': ' + facet.name + ' (' + facet.count + ')'\" v-on:click=\"emitAddFilter(fieldname, facet.name)\" v-bind:tabindex=tabindex class=c-facet-group__facet> <span> {{facet.name}} </span> </button> <span class=c-facet-group__count role=presentation>({{facet.count}})</span> </li> ";

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports = "<div class=c-facet-group> <div class=\"c-search-sidebar__section-title c-search-sidebar__section-title--secondary\" :class=\"{ 'c-search-sidebar__section-title--manuscript-facet-group-title' : isManuscript }\"> <template v-if=isManuscript> {{ trans(\"By\") + \" \" + trans(group.fieldname) + \":\" }} </template> <template v-else> {{ trans(group.fieldname) }} </template> </div> <ul> <facet v-for=\"(facet, index) in group.groups.list\" v-bind:key=\"group.fieldname + ':' + facet.name\" v-bind:facet=facet v-bind:fieldname=group.fieldname v-bind:tabindex=tabindex v-bind:is-manuscript=isManuscript mode=none /> <facet v-for=\"(facet, index) in group.groups.more\" v-bind:key=\"group.fieldname + ':' + facet.name\" v-bind:facet=facet v-bind:fieldname=group.fieldname v-bind:tabindex=tabindex v-bind:is-manuscript=isManuscript mode=overflow /> </ul> <div v-if=hasOverflow class=\"u-hide-medium u-hide-small c-facet-group__facet-wrapper c-facet-group__facet-wrapper--more-options c-facet-group__overflow-wrapper\" v-click-outside=collapseOverflow> <button class=\"c-facet-group__facet c-facet-group__more-options\" v-bind:aria-pressed=\"'' + overflowOpen\" v-bind:aria-controls=\"'overflow-menu-' + group.fieldname\" v-on:click=\"overflowOpen = !overflowOpen\"> {{ trans(\"More options\") }}... </button> <div class=c-facet-group__overflow-bubble-wrapper> <div class=c-facet-group__overflow-bubble v-bind:class=\"{ 'c-facet-group__overflow-bubble--visible': overflowOpen }\" v-bind:id=\"'overflow-menu-' + group.fieldname\" v-bind:aria-expanded=\"'' + overflowOpen\" v-bind:aria-hidden=\"'' + !overflowOpen\"> <div role=presentation class=c-facet-group__arrow aria-hidden=true>&nbsp;</div> <div role=presentation class=c-facet-group__extra-arrow aria-hidden=true>&nbsp;</div> <ul> <facet v-for=\"(facet, index) in group.groups.more\" v-bind:key=\"group.fieldname + ':' + facet.name\" v-bind:facet=facet v-bind:fieldname=group.fieldname v-bind:tabindex=\"overflowOpen ? 0 : -1\" v-bind:is-manuscript=isManuscript mode=overflow-standalone /> </ul> </div> </div> </div> </div> ";

/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports = "<form v-on:submit.prevent=emitQueryChange(value) class=c-search-sidebar__freetext-wrapper> <input class=c-search-sidebar__freetext type=text v-model=currentQuery :placeholder=\"trans('Search Text')\"/><button class=\"c-search-sidebar__submit i-icon i-search-btn_small\" type=submit> {{ trans(\"Search\") }} </button> </form> ";

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports = "<dl class=c-item-metadata> <template v-for=\"metadata in metadataFields\" v-if=manuscriptModel[metadata[1]]> <dt class=c-item-metadata__facet-name>{{ trans(metadata[0]) }}</dt> <dd class=c-item-metadata__facet-wrapper> <a class=c-item-metadata__facet :href=urlForField(metadata)> {{ manuscriptModel[metadata[1]] }} </a> </dd> </template> <template v-if=manuscriptModel.maagarim_link> <dt class=\"u-hide-large u-hide-medium c-item-metadata__facet-name\">{{ trans(\"Transcriptions\") }}</dt> <dd class=\"u-hide-large u-hide-medium c-item-metadata__facet-wrapper\"> <a class=\"c-item-metadata__facet c-item-metadata__facet--transcription\" :href=manuscriptModel.maagarim_link target=_blank> {{trans(\"The Historical Dictionary Project\")}} </a>&nbsp;<span class=\"i-icon i-ext-link\" role=presentation></span> </dd> </template> <div class=u-clearfix></div> </dl> ";

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = "<div class=\"c-search-sidebar u-hide-small\"> <div class=\"u-hide-small c-search-sidebar__section-identity\"> <div v-if=!isManuscript class=c-search-sidebar__page-name> {{trans(\"Browsing Manuscripts\")}} </div> <template v-else> <div class=c-search-sidebar__page-name> {{manuscriptModel.composition_name}} </div> <div class=\"c-search-sidebar__model-id c-search-sidebar__model-id--with-tooltip\"> {{ manuscriptModel.manuscript_number }} {{ manuscriptModel.short_name ? \" - \" + manuscriptModel.short_name : \"\" }} <sup class=u-superscript>{{ manuscriptModel.copy }}</sup> </div> <help-tooltip-toggle :manuscript-name=\"manuscriptModel.manuscript_number + ' ' + (manuscriptModel.short_name ? ' - ' + manuscriptModel.short_name : '')\"/> </template> </div> <freetext-search :value=freetext v-if=!isManuscript /> <template v-if=isManuscript> <manuscript-metadata :manuscript-model=manuscriptModel /> <div class=c-search-sidebar__transcription-wrapper v-if=manuscriptModel.maagarim_link> <div class=\"c-search-sidebar__section-title c-search-sidebar__transcription-title\">{{ trans(\"Transcriptions\") }}</div> <a :href=manuscriptModel.maagarim_link target=_blank> <span class=c-search-sidebar__transcription>{{trans(\"The Historical Dictionary Project\")}}</span>&nbsp;<span class=\"i-icon i-ext-link\" role=presentation></span> </a> </div> </template> <template v-if=\"!isManuscript && filteredSubqueries.length !== 0\"> <div class=\"c-search-sidebar__section-title--filter-chips-title c-search-sidebar__section-title\">{{ trans(\"in\") }}:</div> <filter-chip v-for=\"subquery in filteredSubqueries\" v-bind:key=subquery.text v-bind:filter=subquery /> </template> <template v-if=\"!isManuscript && groups.length !== 0\"> <div class=\"c-search-sidebar__section-title c-search-sidebar__section-title--secondary\">{{ trans(\"add filters\") + \":\" }}</div> <facet-group v-bind:is-manuscript=isManuscript v-for=\"group in groups\" v-bind:key=group.fieldname v-bind:group=group /> </template> <template v-if=\"isManuscript && (groups.length !== 0 || filteredSubqueries.length !== 0)\"> <div class=\"c-search-sidebar__section-title c-search-sidebar__section-title--filter-images\">{{ trans(\"Filter Images\") }}</div> <filter-chip v-for=\"subquery in filteredSubqueries\" v-bind:key=subquery.text v-bind:filter=subquery /> <facet-group v-bind:is-manuscript=isManuscript v-for=\"group in groups\" v-bind:key=group.fieldname v-bind:group=group /> </template> </div> ";

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _translate = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* globals require window console */
var POLLING_INTERVAL = 10;
var SLIDE_TIME = 1250;

exports.default = _vue2.default.component("manuscript-result", {
  props: ["name", "copy", "manuscriptId", "thumbnails", "num-images", "num-comments", "manuscript-number", "index"],
  data: function data() {
    return {
      lastFocusTime: 0,
      hasFocus: false,
      timer: null,
      currentSlide: 0,
      previousSlide: this.thumbnails ? this.thumbnails.length - 1 : 0,
      trans: _translate.trans
    };
  },


  methods: {
    handleFocus: function handleFocus() {
      this.hasFocus = true;
    },
    handleBlur: function handleBlur() {
      this.hasFocus = false;
    },
    timeSinceFocus: function timeSinceFocus() {
      if (this.hasFocus) {
        return Date.now() - this.lastFocusTime;
      } else {
        return 0;
      }
    },
    startTimer: function startTimer() {
      var _this = this;

      this.timer = window.setInterval(function () {
        _this.currentSlide = Math.floor(_this.timeSinceFocus() / SLIDE_TIME) % _this.thumbnails.length;
      }.bind(this), POLLING_INTERVAL);
    },
    stopTimer: function stopTimer() {
      window.clearInterval(this.timer);
    }
  },

  watch: {
    hasFocus: function hasFocus(newVal) {
      if (this.thumbnails) {
        if (newVal) {
          this.lastFocusTime = Date.now();
          this.startTimer();
        } else {
          this.stopTimer();
          this.currentSlide = 0;
        }
      }
    },
    currentSlide: function currentSlide(_, oldVal) {
      this.previousSlide = oldVal;
    }
  },

  template: __webpack_require__(144)
});

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = "<a class=\"o-search-result-layout__item c-manuscript-result\" v-bind:class=\"{'o-search-result-layout__item--third': index % 3 === 0, 'o-search-result-layout__item--second' : index % 2 === 0}\" v-bind:href=\"'/explore-the-archive/manuscript/' + manuscriptId.replace(/\\//g, '_')\" @focus=handleFocus @blur=handleBlur @mouseover=handleFocus @mouseout=handleBlur> <div class=c-manuscript-result__stats-wrapper> <div class=c-manuscript-result__title>{{name.replace(\"-\", \"-\\u200b\")}}<sup class=c-manuscript-result__superscript v-if=\"copy != ''\">{{copy}}</sup></div> <div class=c-manuscript-result__details>{{ manuscriptNumber }}</div> <div class=c-manuscript-result__meta-box> <div class=c-manuscript-result__details>{{ numImages }} {{ trans(\"Images\") }}</div> <div class=c-manuscript-result__comments :class=\"{'c-manuscript-result__comments--focused': hasFocus}\">{{ numComments }} <div class=\"c-image-result__comments-icon i-conversation i-icon\">{{ trans(\"Comments\") }}</div> </div> </div> </div> <div class=c-images-carousel> <div v-for=\"(thumbnail, index) in thumbnails\" class=\"c-images-carousel__item u-hide-medium u-hide-small\" :class=\"{ 'c-images-carousel__item--current': currentSlide === index , 'c-images-carousel__item--previous': previousSlide === index }\" :style=\"{ 'background-image': 'url(' + thumbnail.replace('http://', 'https://') + '=c-s219)' }\" role=presentation></div> <div v-for=\"(thumbnail, index) in thumbnails\" class=\"c-images-carousel__item u-hide-large\" :class=\"{ 'c-images-carousel__item--current': currentSlide === index , 'c-images-carousel__item--previous': previousSlide === index }\" :style=\"{ 'background-image': 'url(' + thumbnail.replace('http://', 'https://') + '=c-s530)' }\" role=presentation></div> </div> </a> ";

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _locale = __webpack_require__(8);

var _locale2 = _interopRequireDefault(_locale);

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _moment = __webpack_require__(3);

var _moment2 = _interopRequireDefault(_moment);

var _translate = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global require */
exports.default = _vue2.default.component("image-result", {
  props: ["name", "url", "photoType", "date", "index", "side", "pamNumber", "plateNumbers", "frag", "numComments"],

  data: function data() {
    return {
      trans: _translate.trans
    };
  },


  computed: {
    formattedDate: function formattedDate() {
      return (0, _moment2.default)(this.date).locale(_locale2.default).format("MMMM YYYY");
    },
    commentNumLoaded: function commentNumLoaded() {
      return this.numComments !== undefined;
    },
    imageStyle: function imageStyle() {
      return {
        "background-image": "url(" + this.url.replace("http://", "https://") + ")"
      };
    },
    plateNumbersAsString: function plateNumbersAsString() {
      return this.plateNumbers.join(", ") + (this.frag !== null ? ", Frag. " + this.frag : "");
    }
  },

  template: __webpack_require__(146)
}); // window global

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports = "<a class=\"o-search-result-layout__item c-image-result\" v-bind:class=\"{'o-search-result-layout__item--third': index % 3 === 0, 'o-search-result-layout__item--second' : index % 2 === 0}\" v-bind:href=\"'/explore-the-archive/image/' + name\"> <div class=c-image-result__image role=presentation v-bind:style=imageStyle> </div> <div class=c-image-result__metadata> <span class=c-image-result__title>{{name}}</span><br/> <div class=c-image-result__plate-numbers> Plate {{ plateNumbersAsString }} </div> <template v-if=pamNumber>PAM {{ pamNumber }} <br/></template> {{trans('Taken')}} {{formattedDate}} <br/> {{photoType}} <br/> {{side}} <div class=c-image-result__comments v-if=commentNumLoaded>{{ numComments }} <div class=\"c-image-result__comments-icon i-icon i-comment\">{{ trans(\"Comments\") }}</div></div> </div> </a> ";

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _locale = __webpack_require__(8);

var _locale2 = _interopRequireDefault(_locale);

var _translate = __webpack_require__(2);

var _clickOutside = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global require window console */

exports.default = _vue2.default.component("help-tooltip-toggle", {
  props: ["manuscriptName"],

  data: function data() {
    return {
      expanded: false,
      collapseTimer: null,
      // Personal ID for this component to prevent clashing
      myId: Math.round(Math.random() * 100000).toString(16),
      trans: _translate.trans
    };
  },


  methods: {
    hide: function hide() {
      this.expanded = false;
    },
    setArrowPosition: function setArrowPosition() {
      var _this = this;

      var windowWidth = window.innerWidth;
      var offset = void 0;

      this.$nextTick(function () {
        var rtl = _locale2.default === "ar_EG" || _locale2.default === "he_IL";

        if (rtl) {
          offset = -window.pageXOffset + 21;
        } else {
          var _$refs$tooltip$getBou = _this.$refs.tooltip.getBoundingClientRect(),
              width = _$refs$tooltip$getBou.width,
              left = _$refs$tooltip$getBou.left;

          var rightEdge = left + width;
          offset = rightEdge - windowWidth + 21;
        }

        if (offset > 0) {
          _this.$refs.arrow.style.transform = "translateX(" + (rtl ? -offset : offset) + "px)";
          _this.$refs.tooltip.style.transform = "translateX(" + (rtl ? offset : -offset) + "px)";
        }
      });
    },
    clearArrowPosition: function clearArrowPosition() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs.arrow.style.transform = "";
        _this2.$refs.tooltip.style.transform = "";
      });
    }
  },

  watch: {
    expanded: function expanded(newVal) {
      if (newVal) {
        this.setArrowPosition();
      } else {
        this.clearArrowPosition();
      }
    }
  },

  directives: {
    clickOutside: _clickOutside.clickOutside
  },

  template: __webpack_require__(148)
});

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports = "<div class=c-help-tooltip__wrapper v-click-outside=hide> <button class=\"c-help-tooltip__button i-icon i-question-icon\" role=switch v-on:click=\"expanded = !expanded\" :aria-checked=expanded :aria-controls=\"'help-tooltip-' + myId\"> {{ trans(\"Help\") }} </button> <div class=c-help-tooltip role=alert aria-live=polite :class=\"{'c-help-tooltip--expanded' : expanded}\" :aria-hidden=!expanded :aria-expanded=expanded :id=\"'help-tooltip-' + myId\" ref=tooltip> <div class=c-help-tooltip__title> <div class=c-help-tooltip__arrow ref=arrow></div> {{ manuscriptName }} </div> {{ trans(\"Contains abbreviations of location, manuscript number, composition name and copy.\") }} <a href=/help#labels class=c-help-tooltip__link>{{trans(\"Learn more\")}}</a> </div> </div> ";

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

__webpack_require__(47);

__webpack_require__(48);

__webpack_require__(50);

__webpack_require__(51);

var _searchSidebar = __webpack_require__(46);

var _searchSidebar2 = _interopRequireDefault(_searchSidebar);

var _eventBus = __webpack_require__(10);

var _bodyScrollLock = __webpack_require__(37);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Global events
/* global require */
exports.default = _vue2.default.component("mobile-search-sidebar", {
  extends: _searchSidebar2.default,

  props: ["state", "currentResults", "totalResults", "standalone"],

  data: function data() {
    return {
      filterMenuOpen: false
    };
  },


  computed: {
    filteredSubqueries: function filteredSubqueries() {
      if (!this.isManuscript) {
        return this.subqueries;
      } else {
        return this.subqueries.filter(function (f) {
          return f.fieldname !== "manuscript_numbers";
        });
      }
    }
  },

  created: function created() {
    var _this = this;

    // Bind global bus events.
    _eventBus.EventBus.$on(["esc-pressed", "query-without-filter", "query-with-filter", "query-with-freetext"], function () {
      _this.collapseFilterMenu();
    });
  },


  methods: {
    collapseFilterMenu: function collapseFilterMenu() {
      this.filterMenuOpen = false;
    }
  },

  watch: {
    filterMenuOpen: function filterMenuOpen(newVal) {
      if (newVal === true) {
        (0, _bodyScrollLock.disableBodyScroll)(this.$refs.filterMenu);
      } else {
        (0, _bodyScrollLock.enableBodyScroll)(this.$refs.filterMenu);
      }
    }
  },

  template: __webpack_require__(150)
});

// Scroll locking


// Import the original sidebar for extension


// Child components
// (not strictly required, due to how extend works in vue, but worth keeping
// for a proper dependency tree)

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports = "<div class=\"u-hide-medium u-hide-large\"> <freetext-search :value=freetext v-if=!isManuscript /> <template v-if=isManuscript> <manuscript-metadata :manuscript-model=manuscriptModel /> <div class=c-tablist__tab-wrapper> <div class=\"c-tablist__tab-title c-heading\"> {{ trans(\"Images\") }} ({{ totalResults }}) <button class=\"c-search-sidebar__add-filter-button c-search-sidebar__add-filter-button--standalone\" v-if=\"groups.length !== 0\" v-bind:aria-pressed=\"'' + filterMenuOpen\" aria-controls=mobile-filter-menu v-on:click=\"filterMenuOpen = !filterMenuOpen\"> {{ trans(\"Filter\") }} </button> </div> </div> </template> <template v-if=\"filteredSubqueries.length !== 0\"> <div class=\"c-search-sidebar__section-title c-search-sidebar__section-title--secondary c-search-sidebar__section-title--mobile-filter-title\">{{ trans(\"Filters\") }}:</div> <div class=c-search-sidebar__all-filter-chips> <filter-chip v-for=\"subquery in filteredSubqueries\" v-bind:key=subquery.text v-bind:filter=subquery /> </div> <button class=c-search-sidebar__add-filter-button v-if=\"groups.length !== 0\" v-bind:aria-pressed=\"'' + filterMenuOpen\" aria-controls=mobile-filter-menu v-on:click=\"filterMenuOpen = !filterMenuOpen\"> + {{ trans(\"Add filter\") }} </button> <status v-if=!isManuscript :state=state :current-results=currentResults :total-results=totalResults /> </template> <template v-else-if=!isManuscript> <status :state=state :current-results=currentResults :total-results=totalResults standalone=true /> <button class=\"c-search-sidebar__add-filter-button c-search-sidebar__add-filter-button--standalone\" v-if=\"groups.length !== 0\" v-bind:aria-pressed=\"'' + filterMenuOpen\" aria-controls=mobile-filter-menu v-on:click=\"filterMenuOpen = !filterMenuOpen\"> {{ trans(\"Filter\") }} </button> </template> <div class=c-search-sidebar__menu-overlay :class=\"{ 'c-search-sidebar__menu-overlay--open': filterMenuOpen }\" role=presentation @click=\"filterMenuOpen = false\"> </div> <div ref=filterMenu class=c-search-sidebar id=mobile-filter-menu v-if=\"groups.length !== 0\" v-bind:class=\"{ 'c-search-sidebar--visible': filterMenuOpen }\" v-bind:aria-expanded=\"'' + filterMenuOpen\" v-bind:aria-hidden=\"'' + !filterMenuOpen\"> <div class=c-search-sidebar__filter-menu-header v-bind:class=\"{ 'c-search-sidebar__filter-menu-header--visible': filterMenuOpen }\"> {{ trans(\"Add filter\") }} <button class=\"i-icon i-close-filters c-search-sidebar__filter-menu-close\" v-bind:tabindex=\"filterMenuOpen ? 0 : -1\" @click=\"filterMenuOpen = false\"> {{ trans(\"Close\") }} </button> </div> <div class=c-search-sidebar__filter-menu-content> <facet-group v-bind:tabindex=\"filterMenuOpen ? 0 : -1\" v-bind:is-manuscript=isManuscript v-for=\"group in groups\" v-bind:key=group.fieldname v-bind:group=group /> </div> </div> </div> ";

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _translate = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global require */

exports.default = _vue2.default.component("status", {
  props: ["state", "currentResults", "totalResults", "standalone"],

  data: function data() {
    return { trans: _translate.trans };
  },


  template: __webpack_require__(152)
});

/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports = "<div class=c-search-page__status :class=\"{'c-search-page__status--standalone': standalone}\"> <template v-if=\"state == 'NO_RESULTS' || state == 'ERROR' || state == 'UNKNOWN'\"> {{ trans(\"No results found\") }} </template> <template v-else-if=\"state == 'INITIAL_LOADING'\"> {{ trans(\"Loading\") }}... </template> <template v-else> {{ trans(\"Showing {x} of {y} Results\").replace(\"{x}\", currentResults).replace(\"{y}\", totalResults) }} </template> </div> ";

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _translate = __webpack_require__(2);

__webpack_require__(154);

__webpack_require__(156);

__webpack_require__(158);

__webpack_require__(23);

__webpack_require__(160);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global require console */
exports.default = _vue2.default.component("tablist", {
  props: ["publications", "about", "notes", "manuscriptId"],

  data: function data() {
    return {
      mobileTabsOpen: [], // Enumerate the tabs open on mobile
      desktopTabOpen: "",
      discussionData: ["Data things"],
      discussionLoaded: false,
      trans: _translate.trans
    };
  },


  watch: {
    desktopTabOpen: function desktopTabOpen(newVal) {
      this.mobileTabsOpen = [newVal];
    }
  },

  created: function created() {
    this.desktopTabOpen = this.allTabs[0];
    this.mobileTabsOpen = [];

    this.fetchComments();
  },


  computed: {
    allTabs: function allTabs() {
      var arr = [];

      if (this.publications) {
        arr.push("publications");
      }

      if (this.notes) {
        arr.push("notes");
      }

      if (this.about) {
        arr.push("about");
      }

      arr.push("discussion");

      return arr;
    },
    hasAbout: function hasAbout() {
      return this.allTabs.indexOf("about") !== -1;
    },
    hasNotes: function hasNotes() {
      return this.allTabs.indexOf("notes") !== -1;
    },
    hasPublications: function hasPublications() {
      return this.allTabs.indexOf("publications") !== -1;
    },
    discussionTitle: function discussionTitle() {
      return this.discussionLoaded && this.discussionData.response.length ? (0, _translate.trans)("Discussion") + " (" + this.discussionData.response.length + ")" : "" + (0, _translate.trans)("Discussion");
    }
  },

  methods: {
    fetchComments: function fetchComments() {
      var _this = this;

      _jquery2.default.get("/api/disqus", {
        endpoint: "/threads/listPosts.json",
        order: "asc",
        thread: "ident:manuscript/" + this.manuscriptId
      }).done(function (data) {
        _this.discussionData = data;
        _this.discussionLoaded = true;
      }).fail(function () {
        return void 0;
      });
    }
  },

  template: __webpack_require__(162)
});

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _vue2.default.component("zippy", {
  props: ["value", "title", "name"],

  data: function data() {
    return {};
  },


  watch: {
    desktopTabOpen: function desktopTabOpen(newVal) {
      this.mobileTabsOpen = [newVal];
    }
  },

  methods: {
    buttonClicked: function buttonClicked() {
      var _this = this;

      if (this.open) {
        this.$emit("input", this.value.filter(function (e) {
          return e !== _this.name;
        }));
      } else {
        this.$emit("input", this.value.concat(this.name));
      }
    }
  },

  computed: {
    open: function open() {
      return this.value.indexOf(this.name) !== -1;
    }
  },

  template: __webpack_require__(155)
}); /* global require */

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports = " <div class=c-tablist__tab-wrapper> <a class=\"c-tablist__tab-title c-heading\" role=button :href=\"'#zippy-' + name\" :class=\"{ 'c-tablist__tab-title--active' : open }\" :aria-controls=\"'zippy-' + name\" :id=\"'zippy-header-' + name\" :aria-expanded=\"'' + open\" @click.prevent=buttonClicked()> {{ title }} <div class=\"i-icon c-tablist__zippy-arrow\" :class=\"{'i-arrowUp': open, 'i-arrowDown': !open}\" role=presentation></div> </a> <div class=c-tablist__tab-content role=region :aria-labelledby=\"'zippy-header-' + name\" :id=\"'zippy-' + name\" v-if=open> <slot></slot> </div> </div> ";

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _translate = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global require */
exports.default = _vue2.default.component("tab-content", {
  props: ["value", "name"],

  data: function data() {
    return {
      trans: _translate.trans
    };
  },


  computed: {
    open: function open() {
      return this.value == this.name;
    }
  },

  template: __webpack_require__(157)
});

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = "<div class=c-tablist__content-wrapper :id=\"'tablist-' + name\"> <div role=tabpanel v-if=open class=c-tablist__tab :aria-labelledby=\"'tab-' + name\" :class=\"{ 'c-tablist__tab--active' : open }\"> <slot></slot> </div> </div> ";

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _vue2.default.component("tab-button", {
  props: ["value", "name", "title"],

  data: function data() {
    return {};
  },


  computed: {
    open: function open() {
      return this.value == this.name;
    }
  },

  template: __webpack_require__(159)
}); /* global require */

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports = " <span> <button class=\"c-tablist__tab-title c-heading\" role=tab :class=\"{ 'c-tablist__tab-title--active' : open }\" :aria-controls=\"'tablist-' + name\" :aria-selected=\"'' + open\" :id=\"'tab-' + name\" @click=\"$emit('input', name)\"> <span>{{ title }}</span> </button> <div class=\"i-icon i-grey-bullet c-tablist__bullet\" v-if=\"name !== 'discussion'\" role=presentation></div> </span> ";

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _translate = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global require */
exports.default = _vue2.default.component("publications", {
  props: ["value"],

  data: function data() {
    return {
      trans: _translate.trans
    };
  },


  template: __webpack_require__(161)
});

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports = "<div> <ol class=c-tab-content__publication-list> <li class=c-tab-content__publication v-for=\"publication in value.list\"> {{publication}} </li> </ol> <a :href=value.orion class=c-tab-content__orion-link target=_blank> {{ trans( \"Additional bibliography:\" ) }} {{ trans( \"The Orion Center\" ) }} <span class=\"i-icon i-ext-link\" role=presentation></span> </a> </div> ";

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports = "<div class=c-tablist> <div class=u-hide-small> <div class=c-tablist__title-wrapper role=tablist> <tab-button v-if=hasPublications v-model=desktopTabOpen name=publications :title=\"trans('Publications')\"/> <tab-button v-if=hasAbout v-model=desktopTabOpen name=about :title=\"trans('About')\"/> <tab-button v-if=hasNotes v-model=desktopTabOpen name=notes :title=\"trans('Notes')\"/> <tab-button v-model=desktopTabOpen name=discussion :title=discussionTitle /> </div> <tab-content v-model=desktopTabOpen name=publications> <publications :value=publications /> </tab-content> <tab-content v-model=desktopTabOpen name=about> <div class=c-tab-content__note-container> <div class=c-tab-content__note> {{ about }} </div> </div> </tab-content> <tab-content v-model=desktopTabOpen name=notes> <div class=c-tab-content__note-container> <div class=c-tab-content__note v-for=\"note in notes\"> {{ note }} </div> </div> </tab-content> <tab-content v-model=desktopTabOpen name=discussion> <discussion v-if=discussionLoaded :data=discussionData /> </tab-content> </div> <div class=\"u-hide-medium u-hide-large\"> <zippy v-if=hasPublications v-model=mobileTabsOpen name=publications :title=\"trans('Publications')\"> <publications :value=publications /> </zippy> <zippy v-model=mobileTabsOpen name=discussion :title=discussionTitle> <discussion v-if=discussionLoaded :data=discussionData /> </zippy> <zippy v-if=hasAbout v-model=mobileTabsOpen name=about :title=\"trans('About')\"> <div class=c-tab-content__note-container> <div class=c-tab-content__note> {{ about }} </div> </div> </zippy> <zippy v-if=hasNotes v-model=mobileTabsOpen name=notes :title=\"trans('Notes')\"> <div class=c-tab-content__note-container> <div class=c-tab-content__note v-for=\"note in notes\"> {{ note }} </div> </div> </zippy> </div> </div> ";

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = "<div class=c-search-page> <search-sidebar v-if=\"pages[0] !== undefined\" :freetext=pages[0].freetext :subqueries=pages[0].subqueries :groups=pages[0].groups :state=state :is-manuscript=isManuscript /> <div class=c-search-sidebar v-else> </div> <div class=c-search-page__content> <div class=\"u-hide-medium u-hide-large\"> <div v-if=!isManuscript class=c-search-sidebar__page-name> {{trans(\"Browsing Manuscripts\")}} </div> <template v-else> <div class=\"c-search-sidebar__page-name c-search-sidebar__page-name--model-name\"> {{manuscriptModel.composition_name}} </div> <div class=c-search-sidebar__model-id> {{ manuscriptModel.manuscript_number }} {{ manuscriptModel.short_name ? \" - \" + manuscriptModel.short_name : \"\" }} <sup class=u-superscript>{{ manuscriptModel.copy }}</sup> <help-tooltip-toggle :manuscript-name=\"manuscriptModel.manuscript_number + ' ' + (manuscriptModel.short_name ? ' - ' + manuscriptModel.short_name : '')\"/> </div> </template> </div> <mobile-search-sidebar v-if=\"pages[0] !== undefined\" :freetext=pages[0].freetext :subqueries=pages[0].subqueries :groups=pages[0].groups :is-manuscript=isManuscript :state=state :current-results=currentResults :total-results=totalResults /> <div class=u-hide-small> <status :state=state :current-results=currentResults :total-results=totalResults /> </div> <div v-if=\"state == 'IDLE' || state == 'LOADING_MORE'\" class=o-search-result-layout__wrapper :class=\"{'o-search-result-layout__wrapper--loading': state === 'LOADING_MORE'}\"> <template v-if=isManuscript> <image-result v-for=\"(result, index) in flatResults\" :index=index :key=result.name :name=result.name :url=result.url :date=result.date :plate-numbers=result.plate_numbers :pam-number=result.pam_num :side=result.side :frag=result.frag_num :photo-type=result.photo_type :num-comments=numComments[result.name] /> </template> <template v-else> <manuscript-result v-for=\"(result, index) in flatResults\" :index=index :key=result.manuscript_id :manuscript-id=result.manuscript_id :name=result.name :thumbnails=result.thumbnails :num-comments=numComments[result.manuscript_id] :num-images=result.num_images :manuscript-number=result.manuscript_number :copy=result.copy /> </template> </div> <div v-else-if=\"loading && state != 'INITIAL_LOADING'\"> {{ trans(\"Loading\") }}... </div> <div class=c-search-page__load-more-wrapper v-if=hasMorePages> <button class=c-search-page__load-more v-bind:disabled=loading v-on:click=getNextPage()> {{ loading ? trans(\"Loading\") + \"...\" : trans(\"Load more results\") }} </button> <div class=c-search-page__load-more-text> {{ trans(\"Showing {x} of {y}\").replace(\"{x}\", currentResults).replace(\"{y}\", totalResults) }} </div> </div> <tablist :publications=\"(manuscriptModel.official_publications.length != 0 || manuscriptModel.orion_link)\n             ? { list: manuscriptModel.official_publications, orion: manuscriptModel.orion_link }\n             : undefined\" :notes=\"manuscriptModel.general_notes.length != 0 ? manuscriptModel.general_notes : undefined\" :about=manuscriptModel.description :manuscript-id=manuscriptModel.manuscript_id v-if=\"isManuscript && state !== 'INITIAL_LOADING'\"/> </div> </div> ";

/***/ }),
/* 164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"breakpointSmall":"767px","breakpointMedium":"1023px"};

/***/ })
],[123]);


// WEBPACK FOOTER //
// js/search.js